module.exports = __webpack_public_path__ + "static/media/home-encryption.b55caf83.svg";